import { defineQuery } from 'next-sanity';

export const getPrintablesCategory = defineQuery(`
   *[_type == "printablesCategory"] | order(title desc){
    _id,
    title,
    slug{
    current
    }
  }
  `);

export const getPrintableSetting = defineQuery(`
  *[_type == "printablesSetting"]{
    title,
    metaDescription,
    header,
    description,
    CSS, JS,
  featuredBigPrintable->{
    _id,
    name,
    thumbnail {
      ...,
      "imgAsset": asset-> {
        ...
      }
    },
    "file":attachment{asset->{url}}
  },
    featuredPrintable1->{
    _id,
    name,
    thumbnail {
      ...,
      "imgAsset": asset-> {
        ...
      }
    },
    "file":attachment{asset->{url}}
    },
    featuredPrintable2->{
    _id,
    name,
    thumbnail {
      ...,
      "imgAsset": asset-> {
        ...
      }
    },
    "file":attachment{asset->{url}}
    },
    featuredPrintable3->{
    _id,
    name,
    thumbnail {
      ...,
      "imgAsset": asset-> {
        ...
      }
    },
    "file":attachment{asset->{url}}
    },
    featuredPrintable4->{
    _id,
    name,
    thumbnail {
      ...,
      "imgAsset": asset-> {
        ...
      }
    },
    "file":attachment{asset->{url}}
    },
}[0]
  `);

export const getAllPrintablesPost = defineQuery(`
   *[_type == "printable" && ($category == null || category->slug.current == $category) && !(_id in $excludeIds)] | order(coalesce(editedDate, _updatedAt) desc){
    _id,
    name,
    thumbnail {
      ...,
      "imgAsset": asset-> {
        ...
      }
    },
    "file":attachment{asset->{url}}
}
`);

export const getPritnables = defineQuery(`
  *[_type == "printable"  && 
    ($excludeIds == null || !(_id in $excludeIds))] | order(coalesce(editedDate, _updatedAt) desc){
    _id,
    name,
    thumbnail {
      ...,
      "imgAsset": asset-> {
        ...
      }
    },
    "file":attachment{asset->{url}},
    category->{
      title
    }
  }
  `);

export const getPrintableSeoData = defineQuery(`
   *[_type == "printablesSetting"]{
   title,
    metaDescription,
   }
  `);
